@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
}

.inner {
    composes: container from "../../styles/composable/layout.module.css";
    position: relative;

    .root & {
        @media ($above-mobile) {
            margin-inline: calc(
                var(--labui-container-margin) + var(--spacer-40)
            );
        }

        @media ($below-mobile) {
            margin-right: 0;
        }
    }
}

.noScrollDesktop {
    @media ($above-tablet) {
        display: flex;
        justify-content: center;
    }
}

.noScrollTablet {
    @media ($above-mobile) {
        display: flex;
        justify-content: center;
    }
}

.noScrollMobile {
    display: flex;
    justify-content: center;
}

.controls {
    position: absolute;
    top: 50%;
    inset-inline: 40px;
    transform: translateY(-50%);
    z-index: 2;
    display: flex;
    justify-content: space-between;

    @media ($below-tablet) {
        inset-inline: 24px;
    }

    @media (hover: none) and (pointer: coarse) {
        display: none;
    }
}

.arrow {
    svg {
        display: block;
        width: var(--spacer-40);
        height: var(--spacer-40);
        fill: var(--color-contrast);
    }
}

.arrowLeft {
    composes: arrow;
    transform: scaleX(-1);
}

.arrowRight {
    composes: arrow;
}

// slides-visible desktop/tablet/mobile values are set in the TSX file
.listItem {
    --slides-visible: var(--slides-visible-desktop);
    --gutters: calc(var(--slides-visible) - 1);
    --gutter-width: var(--spacer-32);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--slides-visible));

    width: var(--width);
    max-height: 100%;
    overflow-y: hidden;
    margin-right: var(--gutter-width);
    vertical-align: top;

    &:last-child {
        margin-right: 0;
    }

    @media ($below-tablet) {
        --slides-visible: var(--slides-visible-tablet);
    }

    @media ($below-mobile) {
        --slides-visible: var(--slides-visible-mobile);
    }
}

.clickable {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    font: var(--font-eyebrow);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-32);
    line-height: 1.3;
    text-align: center;
    text-wrap: wrap;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.imageContainer {
    display: inline-block;
    width: 100%;
    aspect-ratio: 1;
    overflow: hidden;
}

.slide {
    display: flex;
    flex-direction: column;
}

.progressBar {
    @media ($below-mobile) {
        position: relative;
        width: calc(100% - var(--labui-container-margin) * 2);
        height: 4px;
        margin-top: var(--spacer-32);
        margin-left: var(--labui-container-margin);
        border-radius: 4px;
        background: linear-gradient(
            90deg,
            var(--red) var(--scroll-progress-percent),
            var(--off-white) var(--scroll-progress-percent)
        );
    }
}
